import apiClient from '../middleware/apiClient';
import { SSM_FLEXIBLE_OPTIONS, SSM_FLEXIBLE_OPTIONS_CANCEL } from '../helpers/apis';
import {
  COTTON_SSM_FLEXIBLE_OPTIONS,
  COTTON_SSM_FLEXIBLE_OPTIONS_CANCEL,
} from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_FLEXIBLE_OPTIONS = 'GET_FLEXIBLE_OPTIONS';
export const GET_FLEXIBLE_OPTIONS_SUCCESS = 'GET_FLEXIBLE_OPTIONS_SUCCESS';
export const GET_FLEXIBLE_OPTIONS_FAILURE = 'GET_FLEXIBLE_OPTIONS_FAILURE';

function dispatchGetFlexibleOptions(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_SSM_FLEXIBLE_OPTIONS : SSM_FLEXIBLE_OPTIONS;
  return {
    type: GET_FLEXIBLE_OPTIONS,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetFlexibleOptionsSuccess(flexibleOptions) {
  return {
    type: GET_FLEXIBLE_OPTIONS_SUCCESS,
    payload: flexibleOptions,
  };
}

function dispatchGetFlexibleOptionsFailure(error) {
  return {
    type: GET_FLEXIBLE_OPTIONS_FAILURE,
    payload: error,
  };
}

export const getFlexibleOptions = (options = {}) => async (dispatch, getState) => {
  const { flexibleOptions: { cached } = {} } = getState();
  if (cached && !options.force) {
    return null;
  }

  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchGetFlexibleOptions(isCottonSession)).payload;
    return dispatch(dispatchGetFlexibleOptionsSuccess(response));
  } catch (error) {
    dispatch(dispatchGetFlexibleOptionsFailure(error));
    throw error;
  }
};

// Cancel flexible options
export const CANCEL_FLEXIBLE_OPTIONS = 'CANCEL_FLEXIBLE_OPTIONS';
export const CANCEL_FLEXIBLE_OPTIONS_SUCCESS = 'CANCEL_FLEXIBLE_OPTIONS_SUCCESS';
export const CANCEL_FLEXIBLE_OPTIONS_FAILURE = 'CANCEL_FLEXIBLE_OPTIONS_FAILURE';

function dispatchCancelFlexibleOptions(data, isCottonSession = false) {
  const endpoint = isCottonSession
    ? COTTON_SSM_FLEXIBLE_OPTIONS_CANCEL
    : SSM_FLEXIBLE_OPTIONS_CANCEL;
  return {
    type: CANCEL_FLEXIBLE_OPTIONS,
    payload: apiClient.fetch(endpoint, { method: 'POST', body: JSON.stringify(data) }),
  };
}

function dispatchCancelFlexibleOptionsSuccess(payload) {
  return {
    type: CANCEL_FLEXIBLE_OPTIONS_SUCCESS,
    payload,
  };
}

function dispatchCancelFlexibleOptionsFailure(error) {
  return {
    type: CANCEL_FLEXIBLE_OPTIONS_FAILURE,
    payload: error,
  };
}

export const cancelFlexibleOptions = data => async (dispatch) => {
  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchCancelFlexibleOptions(data, isCottonSession)).payload;
    return dispatch(dispatchCancelFlexibleOptionsSuccess(response));
  } catch (error) {
    dispatch(dispatchCancelFlexibleOptionsFailure(error));
    throw error;
  }
};
